var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7368 5.87809C18.2603 7.88708 20.022 8.89157 20.6132 10.203C21.1289 11.3469 21.1289 12.6531 20.6132 13.797C20.022 15.1084 18.2603 16.1129 14.7368 18.1219C11.2134 20.1309 9.45168 21.1354 8.00606 20.9853C6.74512 20.8544 5.59964 20.2013 4.8544 19.1883C4 18.027 4 16.018 4 12C4 7.98203 4 5.97304 4.8544 4.81167C5.59964 3.79868 6.74512 3.14555 8.00606 3.01467C9.45168 2.86461 11.2134 3.86911 14.7368 5.87809Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunProject);
export default __webpack_public_path__ + "static/media/run-project.5077ca137b5219e2a3d90b10410e02cc.svg";
export { ForwardRef as ReactComponent };